import styled, { css } from 'styled-components/macro';
import redisLogo from 'assets/icons/RedisLogo.svg';

const commonContainer = css`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 6;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) =>
    theme.appComponents.components.loginRelatedComponents.commonContainer.backgroundColor};
  overflow: hidden;
`;

const titleCss = css`
  color: ${({ theme }) => theme.appComponents.components.loginRelatedComponents.titleCss.color};
  font-size: 2.8rem;
  font-weight: ${({ theme }) => theme.core.font.fontWeight.bold};
`;

export const ThanksForSignUpContainer = styled.div`
  ${commonContainer};

  & > img:first-of-type {
    position: absolute;
    transform: scale(1.3);
  }

  & button {
    z-index: 1;
  }
`;

export const RedisLogoContainer = styled.div`
  position: absolute;
  top: 3.33rem;
  left: 3rem;
  width: 19rem;
  height: 5.5rem;
  background: url("${redisLogo}") no-repeat;
`;

export const ThanksForSignUpTitle = styled.div`
  ${titleCss};
  margin-bottom: 7.8rem;
`;

export const CheckEmailText = styled.div`
  color: ${({ theme }) =>
    theme.appComponents.components.loginRelatedComponents.checkEmailText.color};
  font-size: 2.2rem;
  font-weight: ${({ theme }) => theme.core.font.fontWeight.bold};
  margin-top: 3.6rem;
  margin-bottom: 1.4rem;
`;

export const ClickMessage = styled.div`
  color: ${({ theme }) => theme.appComponents.components.loginRelatedComponents.clickMessage.color};
  font-size: 1.4rem;
  margin: 0.6rem;
`;
